import React from "react"
import { siteUrl } from "../../../shared/utils/siteUrl"
import Button from "../../../shared/components/atoms/button/button"

import "./competition-element.scss"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"

const CompetitionElement = props => {

  const userInfoEncrypt= encryptUserInfo()

  const datalayerCompetition = (redirection) => {
    pushDataLayerEvent({
      event: "Interacciones - Banners",
      category: "banner_final",
      action: "click",
      label: redirection,
      Location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }
  
  return (
    <div key={props.key} className="f-competition-item">
      <img src={props.urlImg} alt={props.altImg} loading="lazy"/>
      {props.typeButton === "Todos" && (
        <>
          <a 
            href={siteUrl + props.redireccionParaParticipar}
            datalayerCompetition
            onClick={() => {
              datalayerCompetition(props.redireccionParaParticipar)
            }}
          >
            <Button
              className="new-primary-pink short f-consulting-button"
              title="Participa"
            />
          </a>
          <a 
            href={siteUrl + "/magazin/concursos/" + props.slug}
            onClick={() => {
              datalayerCompetition("/magazin/concursos/" + props.slug)
            }}
          >
            <Button
              className="new-primary-pink--outline short f-consulting-button"
              title="Ganadoras"
            />
          </a>
        </>
      )}
      {props.typeButton === "Ganadoras" && (
        <a 
          href={siteUrl + "/magazin/concursos/" + props.slug}
          onClick={() => {
            datalayerCompetition("/magazin/concursos/" + props.slug)
          }}
        >
          <Button
            className="new-primary-pink--outline short f-consulting-button"
            title="Ganadoras"
          />
        </a>
      )}
      {props.typeButton === "Participar" && (
        <a 
          href={siteUrl + props.redireccionParaParticipar}
          onClick={() => {
            datalayerCompetition(props.redireccionParaParticipar)
          }}
        >
          <Button
            className="new-primary-pink short f-consulting-button"
            title="Participa"
          />
        </a>
      )}
    </div>
  )
}

export default CompetitionElement
